var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4797 3.32257C11.5089 4.3518 12.1455 5.77368 12.1455 7.34424C12.1455 10.4854 9.59915 13.0317 6.45801 13.0317C4.88745 13.0317 3.46557 12.3951 2.43634 11.3659M10.4797 3.32257C9.45045 2.29333 8.02858 1.65674 6.45801 1.65674C3.31689 1.65674 0.770508 4.20312 0.770508 7.34424C0.770508 8.91481 1.4071 10.3367 2.43634 11.3659M10.4797 3.32257L2.43634 11.3659",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.598cdd8dcdb51dd08a3513c160349428.svg";
export { ForwardRef as ReactComponent };